/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_massmol_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It is printed on the reagent bottle, or you can compute it from the chemical formula with a molecular weight calculator.`)
};

const es_massmol_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Está impreso en el envase del reactivo, o puedes calcularlo a partir de la fórmula química con una calculadora de peso molecular.`)
};

const de_massmol_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es ist auf der Reagenzflasche aufgedruckt, oder Sie können es aus der chemischen Formel mit einem Molekulargewichtsrechner berechnen.`)
};

const nl_massmol_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit staat op het etiket van de reagensfles, of je kunt het berekenen uit de chemische formule met een molecuulgewichtcalculator.`)
};

const fr_massmol_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elle est imprimée sur le flacon du réactif, ou vous pouvez la calculer à partir de la formule chimique avec un calculateur de masse moléculaire.`)
};

const it_massmol_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È stampato sull'etichetta del reagente, oppure puoi calcolarlo dalla formula chimica con un calcolatore di peso molecolare.`)
};

const pt_br2_massmol_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ele está impresso no rótulo do frasco do reagente, ou você pode calculá-lo a partir da fórmula química com uma calculadora de peso molecular.`)
};

const pt_massmol_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Está impressa no rótulo do reagente, ou pode calculá-la a partir da fórmula química com uma calculadora de massa molecular.`)
};

const ja_massmol_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`試薬ボトルに記載されています。また、分子量計算ツールを使って化学式から計算することもできます。`)
};

const zh_massmol_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分子量印在试剂瓶标签上，也可以用分子量计算器根据化学式计算得出。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const massmol_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.massmol_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("massmol_faq_a2", locale)
	if (locale === "en") return en_massmol_faq_a2(inputs)
	if (locale === "es") return es_massmol_faq_a2(inputs)
	if (locale === "de") return de_massmol_faq_a2(inputs)
	if (locale === "nl") return nl_massmol_faq_a2(inputs)
	if (locale === "fr") return fr_massmol_faq_a2(inputs)
	if (locale === "it") return it_massmol_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_massmol_faq_a2(inputs)
	if (locale === "pt") return pt_massmol_faq_a2(inputs)
	if (locale === "ja") return ja_massmol_faq_a2(inputs)
	return zh_massmol_faq_a2(inputs)
};